// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Il2B","colBig":"styles_colBig__2Fu38","colSmall":"styles_colSmall__1Q62h"};